// non-breaking spaces are used as space separators by Intl formatters
export const NARROW_NO_BREAK_SPACE = '\u202f'
export const NO_BREAK_SPACE = '\u00A0'
